"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAutocomplete = void 0;
const react_1 = require("react");
const useAutocomplete = (args) => {
    const [list, setList] = (0, react_1.useState)([]);
    const handleGetAutocomplete = () => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield fetch('https://pmapi.reeltime.no/newapi/autocomplete', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                q: args.query.toLowerCase(),
            }),
        });
        const data = yield res.json();
        if (data && data[0] && data[0].options && data[0].options.length) {
            setList(data[0].options);
        }
    });
    return { list, handleGetAutocomplete };
};
exports.useAutocomplete = useAutocomplete;
//# sourceMappingURL=use-autocomplete.js.map